export const applyValueOrArray =
  <TInput>(fn: (s: TInput) => TInput) =>
  <TReturn extends TInput | TInput[]>(s: TReturn): TReturn =>
    s instanceof Array
      ? (s.map(fn) as TReturn)
      : (fn(s as unknown as TInput) as unknown as TReturn);
